module.exports = __webpack_public_path__ + "img/img-main-bg-08-m.15fd699e.png";